import DefaultTippy from '@tippyjs/react';
import { LazyTippy } from './LazyTippy';

const Tippy = Object.assign(DefaultTippy, {
    Lazy: LazyTippy
});

export default Tippy;
